import { useEffect, useState } from 'react';
import { ZoomInfoService } from 'service/zoominfo.service';

export const useBusinessDetails = (id: string) => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDetails = async (id: string) => {
      try {
        setLoading(true);
        const res = await ZoomInfoService.getCompanyDetails(id);
        setData(res);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    getDetails(id);
  }, [id]);

  return { data, loading };
};
